<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="添加项目"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="项目名称：" prop="contractCode" class="input-with-col2 mr0">
          <el-input
            size="mini"
            v-model.trim="form.contractCode"
            placeholder="请输入项目名称"
            clearable 
          >
          </el-input>
        </el-form-item>
        <el-form-item label="服务时间：" class="input-with-col2 mr0">
          <el-date-picker
            v-model="form.createTimeBetween"
            size="mini"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
            unlink-panels
            clearable
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      form: {
        contractCode: "",
        createTimeBetween: [],
      },
      rules: {
        contractCode: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        createTimeBetween: [
          {
            required: true,
            message: "请选择服务时间",
            trigger: "change",
          },
        ],
      },
    };
  },

  components: {},
  created() {},
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const params = { ...this.form };
          params.sex = params.sex * 1;
          const res = await saveUser(params);
          if (res.code === 200) {
            this.$message.success("添加成功");
            this.$emit("confirm");
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.liftInfo {
  .liftInfo-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ContractManagement/components/AddProject.vue